export default "__VITE_ASSET__B495mmMv__"